import { TipoContrato } from './tipo-contrato.interface';
import { TipoContratoDto } from './tipo-contrato.dto';

export class TipoContratoMapper {
  static fromDto(dto: TipoContratoDto): TipoContrato {
    return {
      tipoContratoId: dto.tipoContrato_ID,
      nombre: dto.nombre
    };
  }

  static fromDtoList(dtoList: TipoContratoDto[]): TipoContrato[] {
    return dtoList.map(dto => this.fromDto(dto));
  }

  static toDto(model: TipoContrato): TipoContratoDto {
    return {
      tipoContrato_ID: model.tipoContratoId,
      nombre: model.nombre
    };
  }
}
